<header>
  <div class="page-info">
    <!--<dx-button routerLink="/" icon="home"></dx-button>-->
    <h2>{{page}}</h2>
  </div>
  <div class="button-group">
    <dx-button id="logList" (onClick)="listLogs()" >
      <i class="dx-icon-eventall"></i>
    </dx-button>
  </div>
</header>

@if(logs){
  <dx-context-menu
    target="#logList"
    (onItemClick)="itemClicked($event)"
    [(visible)]="showLogs"
    itemTemplate="logsTemplate"
    [items]="logs"
    [position]="{my: 'top', at: 'bottom', offset: {y: 10} }">
    <div *dxTemplate="let log of 'logsTemplate'" class="row task-element">
      <span>{{log.description}}</span>

      @switch(log.status) {
        @case (TaskStatus.IN_PROGRESS) {
          <span class="progress"><i class="dx-icon-refresh"></i></span>
        }
        @case (TaskStatus.FAILED) {
          <span><i class="dx-icon-clearsquare invalid"></i></span>
        }
        @case (TaskStatus.SUCCESS) {
          <span><i class="dx-icon-todo"></i></span>
        }
        @case (TaskStatus.WARNING) {
          <span><i class="dx-icon-warning log-status warning"></i></span>
        }
        @default {
          <span><i class="dx-icon-square"></i></span>
        }
      }
    </div>
  </dx-context-menu>
}

@if(showTaskPopup) {
  <app-task-logs-component [(task)]="selectedTask" [(visible)]="showTaskPopup"></app-task-logs-component>
}
